var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDbnN = function SvgDbnN(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0.176514C9.4095 0.176514 0 9.58601 0 21.1765C0 32.767 9.4095 42.1765 21 42.1765C32.5905 42.1765 42 32.767 42 21.1765C42 9.58601 32.6217 0.176514 21 0.176514ZM21 36.9733C12.276 36.9733 5.23442 29.9006 5.23442 21.2077C5.23442 12.5148 12.3071 5.41094 21 5.41094C29.6929 5.41094 36.7656 12.4836 36.7656 21.1765C36.7656 29.8694 29.6929 36.9421 21 36.9421",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7908 30.8976H12.5564V11.5178H17.635V13.9169C18.819 11.9228 21.1246 11.0192 23.2122 11.0192C28.0104 11.0192 30.2226 14.4465 30.2226 18.6839V30.8976H24.9881V19.5875C24.9881 17.4376 23.9288 15.724 21.405 15.724C19.1306 15.724 17.7908 17.5 17.7908 19.7433V30.8976Z",
    fill: "inherit"
  })));
};
export default SvgDbnN;